import {
  type Configuration,
  LogLevel,
  type RedirectRequest,
  type SilentRequest,
} from "@azure/msal-browser";

const clientId = import.meta.env.VITE_AAD_CLIENT_ID;
const tenantId = import.meta.env.VITE_AAD_TENANT_ID;
const redirectUri = import.meta.env.VITE_REDIRECT_URI ?? window.location.origin;

if (!clientId || !tenantId) {
  throw new Error(
    "Missing VITE_AAD_CLIENT_ID or VITE_AAD_TENANT_ID. Copy .env.example to .env.local and fill them in."
  );
}

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// User.Read.All is required to look up OTHER users (AI Champions'
// job title/photo) via /users/{id} — User.Read alone only covers the
// signed-in user's own /me profile.
export const graphScopes = ["User.Read", "User.Read.All", "Sites.ReadWrite.All"];

export const loginRequest: RedirectRequest = {
  scopes: graphScopes,
};

export const silentRequest: SilentRequest = {
  scopes: graphScopes,
};

/**
 * Power Platform scope for invoking the Copilot Studio agent.
 * Tokens for this scope are acquired separately from Graph tokens —
 * Entra issues one access token per resource.
 */
export const agentScopes = [
  "https://api.powerplatform.com/CopilotStudio.Copilots.Invoke",
];

export const agentRequest: SilentRequest = {
  scopes: agentScopes,
};
